import { IProject } from '../interfaces/IProject';

export const projectData: IProject[] = [
    {
        title: "Qwerkey E-store",
        year: 2023,
        description: "Developed a ground-up web-facing e-commerce platform to sell keyboard parts at the criteria of a Product Owner using an Agile methodology and Angular/Spring Boot/REST API, won best group out of 40 people. Configured all machines and led Git development along with MongoDB integration /connection. Designed DAO patterns to manage and store product and account data, enabling efficient data retrieval",
        technologies: ["Java", "Springboot", "Angular", "Typescript", "HTML & CSS", "MongoDB"],
        url: "https://www.rit.edu/study/software-engineering-bs",
        image: "qwerkey.png",
    },
    {
        title: "HitsToFits",
        year: 2023,
        description: "Implemented a goal-based learning AI algorithm with a team of four to compare a user's song data and articles of clothing to recommend an outfit. Stored and classified clothing images using Google Cloud Vision AI and Storage API.",
        technologies: ["Flask", "Google Cloud", "Google Storage", "Google Vision AI", "Python", "Spotify API"],
        url: "https://devpost.com/software/hits-to-fits",
        image: "hits-to-fits.png",
    },
    {
        title: "Love @ First Bite",
        year: 2022,
        description: "Worked with a team of four people to develop a mobile app that promotes eating at local/minority-owned restaurants through a like/dislike matching system. Used React Native and Google Firebase to create the app's functionality on both IOS and Android platforms. Showcased and demoed this project to M&T Software Engineers and won best UI/UX.",
        technologies: ["Flask", "React Native", "Python", "HTML & CSS"],
        url: "https://devpost.com/software/love-first-bite",
        image: "love-at-first-bite.png",
    },
    {
        title: "Illness Tracker",
        year: 2022,
        description: "Designed and developed an illness tracker for users to log symptoms into MongoDB and kept a visual graph of their illness severity to better represent patterns, leading to 2nd place out of 5 others teams. Presented the project to about 15 M&T Software Engineers and received positive feedback.",
        technologies: ["Java", "JFreeCharts", "MongoDB"],
        url: "https://devpost.com/software/illness-tracker",
        image: "illness-tracker.jpg",
    },
    {
        title: "Wall Scraper",
        year: 2022,
        description: "Developed a web scraper to scrape and download about 20 high quality wallpapers to the hard drive from HTML links while allowing the user to choose from any category. Implemented a text-based command interface to handle directory creation, parsing a category, and to quit.",
        technologies: ["Python", "Beautiful Soup", "Requests", "HTML"],
        url: "https://github.com/tusmm/wallscraper",
        image: "wall-scraper.jpg",
    },
    {
        title: "Trie Database of IP addresses",
        year: 2022,
        description: "Implemented all parts of a trie tree database and parsed input files for locations and IP addresses in order to sort, query, and display different parts of the data. Problem solved solutions via whiteboard and maintained documentation standards.",
        technologies: ["C"],
        url: "",
        image: "",
    },
    {
        title: "3-in-a-Row",
        year: 2023,
        description: "Created a clone of the puzzle game, 3-in-a-Row game with a backtracking algorithm as a solver. Maintained documentation standards and problem solved algorithms that were plausible",
        technologies: ["C"],
        url: "https://www.brainbashers.com/3inarow.asp",
        image: "",
    },
    {
        title: "Miner Issues",
        year: 2024,
        description: "Two miners. Half the controls. One goal: get out.",
        technologies: ["Python", "Pygame"],
        url: "https://devpost.com/software/miner-issues",
        image: "",
    },
    {
        title: "Compiler",
        year: 2024,
        description: "Academic project. Developed a compiler for a custom programming language. Implemented lexical analysis, parsing, and code generation.",
        technologies: ["Java"],
        url: "https://github.com/tusmm/PLC-CSCI-344",
        image: "",
    },
    {
        title: "Odin Project - Play through",
        year: 2024,
        description: "Play through of the Odin Project curriculum.",
        technologies: ["HTML", "CSS", "JavaScript"],
        url: "https://tusmm.github.io/shmodin/",
        image: "",
    },
];